import type * as Types from 'app/types/graphql';

export type ClickedElementSelectFragment = Pick<
  Types.ClickedElement,
  | 'hash'
  | 'selector'
  | 'totalClicks'
  | 'totalOrders'
  | 'totalRevenue'
  | 'totalSessions'
  | 'totalSessionsThatCompletedCheckout'
  | 'totalClicksWithRevenue'
>;

export const ClickedElementSelectFragmentDoc = `
    fragment ClickedElementSelect on ClickedElement {
  hash
  selector
  totalClicks
  totalOrders
  totalRevenue
  totalSessions
  totalSessionsThatCompletedCheckout
  totalClicksWithRevenue
}
    `;
